import { useMemo } from 'react';

import { useListEvents } from '@givebacks/api/store';
import { useNavigate } from 'react-router-dom';
import { EventCard, Modal, ModalProps, SimpleGrid, useMantineTheme } from 'ui';
import { useMediaQuery } from 'ui/Hooks';

type ViewAllEventsModalContentProps = {
  causeId?: string;
};

const ViewAllEventsModalContent = ({ causeId }: ViewAllEventsModalContentProps) => {
  const { breakpoints } = useMantineTheme();
  const navigate = useNavigate();
  const isLargerThanMedium = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const { data: events } = useListEvents({
    causeId,
    queryOptions: {
      searches: {
        live: {
          value: true,
        },
      },
      options: {
        include: 'event_dates',
      },
    },
  });

  const renderedEvents = useMemo(() => {
    if (!events) return null;

    return events?.store_items?.map((event) => (
      <EventCard
        key={event.uuid}
        imageSrc={event.images?.[0]?.url}
        thumbnailSrc={event.thumbnail?.url}
        name={event.name}
        onClick={() => navigate(`events/${event.uuid}`)}
        start_date={event.earliest_starting_at}
        end_date={event.latest_ending_at}
        isColumn={isLargerThanMedium}
      />
    ));
  }, [events, isLargerThanMedium, navigate]);

  return (
    <SimpleGrid cols={{ base: 1, md: 3 }} spacing={{ base: 'sm', md: 'md' }}>
      {renderedEvents}
    </SimpleGrid>
  );
};

type ViewAllEventsModalProps = ModalProps & {
  causeId?: string;
};

const ViewAllEventsModal = ({ opened, onClose, causeId }: ViewAllEventsModalProps) => {
  return (
    <Modal title="Ticketed Events" opened={opened} onClose={onClose} size="lg">
      <ViewAllEventsModalContent causeId={causeId} />
    </Modal>
  );
};

export { ViewAllEventsModal };
